import { createContext, type ReactNode, useContext, useState } from 'react';

export interface Tenant {
  id: string;
  name: string;
  code: string;
}

interface TenantContextType {
  selectedTenant: Tenant | null;
  setSelectedTenant: (tenant: Tenant | null) => void;
  refreshTenant: () => Promise<void>;
}

const TenantContext = createContext<TenantContextType | undefined>(undefined);

export function TenantProvider({ children }: { children: ReactNode }) {
  const [selectedTenant, setSelectedTenant] = useState<Tenant | null>(null);

  const refreshTenant = async () => {
    if (!selectedTenant) return;
    // Re-fetch logic could be here, but for now we just trigger others
    console.log('Refreshing tenant info...');
  };

  return (
    <TenantContext.Provider value={{ selectedTenant, setSelectedTenant, refreshTenant }}>
      {children}
    </TenantContext.Provider>
  );
}

export function useTenant() {
  const context = useContext(TenantContext);
  if (context === undefined) {
    throw new Error('useTenant must be used within a TenantProvider');
  }
  return context;
}
